<template>
  <el-dialog :title="title"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             width="600px"
             @close="handleClose">
    <div class="mian">
      <div class="mian-status">
        <div class="icon">
          <i :class="title == '支付成功'  ? 'el-icon-success' : 'el-icon-error'"
             :style="{color: title == '支付成功' ? '#14C855' : '#E72F0D'}"></i>
          <p>{{title}}</p>
        </div>

        <div class="int-btn">
          <el-button type="primary"
                     v-if="title == '支付成功'"
                     @click="handleClick(1)">开通收款账户</el-button>
          <el-button 
           v-if="title == '支付失败'"
                     @click="handleClose">重新支付</el-button>
        </div>
        <div class="info" v-if="title=='支付成功'">
            <p>请去<span style="color:red">店铺信息</span>中开通收款账户</p>
          <p><span>*温馨提示：</span>收款账户用于消费者下单时的收款，不开</p>
          <p>通将会影响商品发布，为了更快运营请尽快开通~</p>
        
        </div>
        <div class="info" v-else>
          <p><span>*温馨提示：</span>如果重新支付还是出现支付失败，可反馈官方客服，</p>
          <p>客服电话：021-61311883</p>
        </div>

      </div>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      require: true,
    },
    order_amount: {
      require: true,
    },
    order_sn: {
      require: true,
    },
    code: {
      require: true,
    },
  },
  data () {
    return {
      dialogVisible: true
    };
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    handleClick () {

      this.$router.push('/home/shopInfoManage')
     /*    this.$refs.refShopInfo.dialogVisible = true;
        this.$refs.refShopInfo.id =  this.shop_id;
        this.$refs.refShopInfo.handleClick(); */
      /*    num == 1 ? this.$router.go(0) : this.$router.push('/home/shopInfoManagel') */
    }
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.mian {
  width: 100%;
  height: 420px;
  .mian-status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .icon {
      font-size: 100px;
      //  text-align: center;
     // margin-bottom: 20px;
      p {
        font-size: 18px;
        margin: 20px 0;
        text-align: center;
      }
    }
    .info {
      font-size: 16px;
      padding: 10px 0;
      p {
        padding: 2px 0;
        color: #000;
        font-size: 14px;
        text-align: center;
        span {
          font-size: 15px;
        }
      }
    }
  }
  .int-btn {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    width: 300px;
    ::v-deep .el-button {
      width: 160px;
      height: 32px;
    }
    ::v-deep .el-button--primary {
      color: #fff;
      background-color: #2448ff;
      border-color: #2448ff;
    }
  }
}
</style>
